export const environment = {
  production: false,
  datastoreUrl: 'https://bk-test.internal.sparbankensyd.se/kalp',
  domain: 'bk-stage.internal.sparbankensyd.se',
  authServiceUrl: 'https://bk-test.internal.sparbankensyd.se/service',
  rtUrl: 'https://bk-test.internal.sparbankensyd.se/interests',
  testMode: true
}
